import React from "react";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import {
  aboutLinks,
  alternativesLinks,
  communityLinks,
  guidesLinks,
  productLinks,
  resourcesLinks,
  topFeatures,
  topSoftwareTools,
} from "./footerData";

const logo = "/gainss-logo.png";

const SecondaryFooter = () => {
  return (
    <Container className="py-4 secondary-footer">
      <Row>
        <Col md={2} sm={6} xs={6} className="mb-3">
          <ListGroup variant="flush">
            <ListGroup.Item className="p-1 border-0">
              <img width="125px" src={logo} alt="Logo" />
            </ListGroup.Item>
            {aboutLinks.map((link, index) => (
              <ListGroup.Item key={index} className="p-1 border-0">
                {link.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
        <Col md={2} sm={6} xs={6} className="mb-3">
          <h5>Product</h5>
          <ListGroup variant="flush">
            {productLinks.map((link, index) => (
              <ListGroup.Item key={index} className="p-1 border-0">
                {link.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
        <Col md={2} sm={6} xs={6} className="mb-3">
          <h5>Community</h5>
          <ListGroup variant="flush">
            {communityLinks.map((link, index) => (
              <ListGroup.Item key={index} className="p-1 border-0">
                {link.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
        <Col md={2} sm={6} xs={6} className="mb-3">
          <h5>Guides</h5>
          <ListGroup variant="flush">
            {guidesLinks.map((link, index) => (
              <ListGroup.Item key={index} className="p-1 border-0">
                {link.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
        <Col md={2} sm={6} xs={6} className="mb-3">
          <h5>Resources</h5>
          <ListGroup variant="flush">
            {resourcesLinks.map((link, index) => (
              <ListGroup.Item key={index} className="p-1 border-0">
                {link.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
        <Col md={2} sm={6} xs={6} className="mb-3">
          <h5>Alternatives</h5>
          <ListGroup variant="flush">
            {alternativesLinks.map((link, index) => (
              <ListGroup.Item key={index} className="p-1 border-0">
                {link.name}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <h6>Top Features</h6>
          <ListGroup horizontal className="flex-wrap">
            {topFeatures.map((feature, index) => (
              <li key={index} className="p-1 border-0 me-3">
                {feature.name}
              </li>
            ))}
          </ListGroup>
        </Col>
      </Row>
      {/* <hr />
      <Row>
        <Col>
          <h6>Top Software Testing Tools</h6>
          <ListGroup horizontal className="flex-wrap">
            {topSoftwareTools.map((feature, index) => (
              <li key={index} className="p-1 border-0 me-3">
                {feature.name}
              </li>
            ))}
          </ListGroup>
        </Col>
      </Row> */}
    </Container>
  );
};

export default SecondaryFooter;
